<template>
    <record-choose-item
        v-bind:className="'choose-record-choose-item'"
        v-bind:recordData="source"
        v-bind:itemFunc="chooseRecordChooseItem">
    </record-choose-item>
</template>

<script>
import RecordChooseItem from './record/RecordChooseItem.vue'
export default {
    name: 'ChooseRecordChooseItem',
    components: { RecordChooseItem },
    props: {
        source: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    methods: {
        chooseRecordChooseItem(data){
            let curPath = this.$router.history.current.path;
            if(curPath.indexOf('discussmain') != -1 || curPath.indexOf('discusssecond') != -1 
                || curPath.indexOf('famouspedia') != -1 || curPath.indexOf('famouspediacreate') != -1
                || curPath.indexOf('marriage') != -1 ) {
                this.$store.dispatch('chooserecord/chooseSingleRecordItem', data);
            }
            if(curPath.indexOf('contrastlist') != -1 || curPath.indexOf('contrast') != -1 || curPath.indexOf('detail') != -1) {
                let userVip = this.$store.state.userData.vip;
                let itemList = this.$store.state.chooserecord.choosedMultipleItemList;
                let selectedLen = this.$store.state.chooserecord.defaultSelectedListLength;
                let totalLength = itemList.length + selectedLen;
                    totalLength = curPath.indexOf('detail') != -1 || curPath.indexOf('contrast/contrastlist') != -1 ? totalLength+1 : totalLength;
                console.log('------', totalLength, itemList, selectedLen)
                if(data.selected && data.selectDisabled) { return; }
                if(data.selected) {
                    if((userVip == 0 && totalLength >= 4) || (userVip == 10 && totalLength >= 8)) {
                        let tText = userVip == 0 ? '非会员最多只能对比4个八字' : '月会员最多只能对比8个八字';
                        this.$toast(tText);
                        this.$store.dispatch('user/showMyVipPop', {vip: userVip, frompage: 'compare_choose'});
                        data.selected = false;
                        setTimeout(() => {
                            this.$bus.emit('initMyVipPage');
                        }, 20);
                        return;
                    }
                }
                this.$store.dispatch('chooserecord/chooseMultipleRecordItem', data);
            }
            if(curPath.indexOf('sendbzselect') != -1) {
                this.$store.dispatch('chooserecord/chooseMultipleRecordItem', data);
            }
        },
    }
}
</script>
